import React, { useState } from 'react';
import { Row, Col, Label, Input, FormGroup, Card, CardHeader, CardBody, Collapse } from 'reactstrap';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';

import './Lmu.css';

const AdditionalInformation = ({ form, isSameAsMaster, handleFormFieldChange, additionalInfoIsOpen,  additionalInfoIsIconUp,  additionalInfoToggle }) => {
    

    return (

        <div>

            {isSameAsMaster != true &&
                <>
                    <Row>
                        <Col sm="4">
                            <FormGroup id="divtopographyId">
                                <Label
                                    for="topographyId"
                                >
                                    Topography
                                </Label>
                                <Input
                                    bsSize="sm"
                                    type="select"
                                    value={form.topographyId}
                                    onChange={handleFormFieldChange}
                                    name="topographyId"
                                    id="topographyId"
                                >
                                    <option value={0} >Select Topography</option>
                                    {form.topographyList.map(c =>
                                        <option key={c.id} value={c.id}>{c.value}</option>
                                    )}
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="4">
                            <FormGroup id="divsoilTypePredominantId">
                                <Label
                                    for="soilTypePredominantId"
                                >
                                    Soil Type (Predominant)
                                </Label>
                                <Input
                                    bsSize="sm"
                                    type="select"
                                    value={form.soilTypePredominantId}
                                    onChange={handleFormFieldChange}
                                    name="soilTypePredominantId"
                                    id="soilTypePredominantId"
                                >
                                    <option value={0} >Select Soil Type</option>
                                    {form.soilTypePredominantList.map(c =>
                                        <option key={c.id} value={c.id}>{c.value}</option>
                                    )}
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col sm="4">
                            <FormGroup>
                                <Label for="soilTypePredominantPercentage"> Soil Type % (Predominant) </Label>
                                <Input
                                    type="text"
                                    name="soilTypePredominantPercentage"
                                    id="soilTypePredominantPercentage"
                                    bsSize="sm"
                                    value={form.soilTypePredominantPercentage}
                                    onChange={handleFormFieldChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col sm="4">
                            <FormGroup>
                                <Label for="drainabilityPredominant">Drainability</Label>
                                <Input
                                    bsSize="sm"
                                    value={form.drainabilityPredominant}
                                    onChange={handleFormFieldChange}
                                    id="drainabilityPredominant"
                                    name="drainabilityPredominant"
                                    type="select"
                                >
                                    <option value={0} >Select Drainability</option>
                                    {form.drainabilityPredominantList?.map(c =>
                                        <option key={c.id} value={c.id}>{c.value}</option>
                                    )}
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="4">
                            <FormGroup>
                                <Label
                                    for="soilTypeOtherId"
                                >
                                    Soil Type (Other)
                                </Label>
                                <Input
                                    bsSize="sm"
                                    type="select"
                                    value={form.soilTypeOtherId}
                                    onChange={handleFormFieldChange}
                                    name="soilTypeOtherId"
                                    id="soilTypeOtherId"
                                >
                                    <option value={0} >Select Soil Type</option>
                                    {form.soilTypeOtherList.map(c =>
                                        <option key={c.id} value={c.id}>{c.value}</option>
                                    )}
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col sm="4">
                            <FormGroup>
                                <Label for="soilTypeOtherPercentage" > Soil Type % (Other) </Label>
                                <Input
                                    type="text"
                                    name="soilTypeOtherPercentage"
                                    id="soilTypeOtherPercentage"
                                    bsSize="sm" value={form.soilTypeOtherPercentage}
                                    onChange={handleFormFieldChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col sm="4">
                            <FormGroup>
                                <Label for="drainabilityOther">Drainability</Label>
                                <Input
                                    bsSize="sm"
                                    value={form.drainabilityOther}
                                    onChange={handleFormFieldChange}
                                    id="drainabilityOther"
                                    name="drainabilityOther"
                                    type="select"
                                >
                                    <option value={0} >Select Drainability</option>
                                    {form.drainabilityOtherList.map(c =>
                                        <option key={c.id} value={c.id}>{c.value}</option>
                                    )}
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                </>
            }
        </div>

        //<Card className="my-3">
        //    <CardHeader className="card-header-click" onClick={additionalInfoToggle}>
        //        <Row>
        //            <Col sm="11">
        //                <h6>Effective Area, Soils and Drainability&nbsp;<span style={{ color: "red", fontSize: "13px" }}>(expand to enter soil and topography)</span></h6>
        //            </Col>
        //            <Col sm="1" className="toggleoutline_lt">{additionalInfoIsIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
        //        </Row>
        //    </CardHeader>
        //    <Collapse isOpen={additionalInfoIsOpen}>
        //        <CardBody>
        //            <Row>
        //                <Col sm="6">
        //                    <FormGroup check>
        //                        <Label
        //                            check
        //                            for="isNonEffectiveArea"
        //                        >
        //                            Non-effective area?
        //                        </Label>
        //                        <Input
        //                            defaultChecked={form.isNonEffectiveArea}
        //                            id="isNonEffectiveArea"
        //                            name="isNonEffectiveArea"
        //                            type="checkbox"
        //                            value={form.isNonEffectiveArea}
        //                            onChange={(e) => handleFormFieldChange(e)}
        //                        />
        //                    </FormGroup>
        //                </Col>
        //                <Col sm="6">
        //                    {!form.isNonEffectiveArea &&
        //                        <FormGroup>
        //                            <Label for="effectiveArea">Effective (ha)</Label>
        //                            <Input
        //                                disabled={false}
        //                                type="text"
        //                                name="effectiveArea"
        //                                id="effectiveArea"
        //                                bsSize="sm"
        //                                value={form.effectiveArea}
        //                                onChange={(e) => handleFormFieldChange(e)}
        //                            />
        //                        </FormGroup>
        //                    }
        //                </Col>
        //            </Row>
        //            <Row>
        //                <Col sm="6">
        //                    <FormGroup check>
        //                        <Label
        //                            check
        //                            for="isLeasedBlock"
        //                        >
        //                            Leased or contains leased area?
        //                        </Label>
        //                        <Input
        //                            defaultChecked={form.isLeasedBlock}
        //                            id="isLeasedBlock"
        //                            name="isLeasedBlock"
        //                            type="checkbox"
        //                            value={form.isLeasedBlock}
        //                            onChange={(e) => handleFormFieldChange(e)}
        //                        />
        //                    </FormGroup>
        //                </Col>
        //                <Col sm="6">
        //                    {form.isLeasedBlock == true &&
        //                        <FormGroup>
        //                            <Label for="leasedAreaHa">Leased area (ha)</Label>
        //                            <Input
        //                                disabled={false}
        //                                type="text"
        //                                name="leasedAreaHa"
        //                                id="leasedAreaHa"
        //                                bsSize="sm"
        //                                value={form.leasedAreaHa}
        //                                onChange={(e) => handleFormFieldChange(e)}
        //                            />
        //                        </FormGroup>
        //                    }
        //                </Col>
        //            </Row>
        //            <Row className="my-3">
        //                <Col sm="6">
        //                    <FormGroup check>
        //                        <Label
        //                            check
        //                            for="isReceivesLiquidEffluent"
        //                        >
        //                            Receives Liquid Effluent?
        //                        </Label>
        //                        <Input
        //                            defaultChecked={form.isReceivesLiquidEffluent}
        //                            checked={form.isReceivesLiquidEffluent}
        //                            id="isReceivesLiquidEffluent"
        //                            name="isReceivesLiquidEffluent"
        //                            type="checkbox"
        //                            value={form.isReceivesLiquidEffluent}
        //                            onChange={handleFormFieldChange}
        //                        />
        //                    </FormGroup>
        //                </Col>
        //                <Col sm="6">
        //                    <FormGroup check>
        //                        <Label
        //                            check
        //                            for="isReceivesFreshWaterIrrigation"
        //                        >
        //                            Irrigated?
        //                        </Label>
        //                        <Input
        //                            defaultChecked={form.isReceivesFreshWaterIrrigation}
        //                            checked={form.isReceivesFreshWaterIrrigation}
        //                            id="isReceivesFreshWaterIrrigation"
        //                            name="isReceivesFreshWaterIrrigation"
        //                            type="checkbox"
        //                            value={form.isReceivesFreshWaterIrrigation}
        //                            onChange={handleFormFieldChange}
        //                        />
        //                    </FormGroup>
        //                </Col>
        //            </Row>
        //            {isSameAsMaster != true &&
        //                <>
        //                    <Row>
        //                        <Col sm="4">
        //                            <FormGroup>
        //                                <Label
        //                                    for="stemCountPerHa"
        //                                >
        //                                    Stem Count per Ha
        //                                </Label>
        //                                <Input
        //                                    type="text"
        //                                    name="stemCountPerHa"
        //                                    id="stemCountPerHa"
        //                                    bsSize="sm"
        //                                    value={form.stemCountPerHa}
        //                                    onChange={handleFormFieldChange}
        //                                />
        //                            </FormGroup>
        //                        </Col>
        //                        <Col sm="4">
        //                        <FormGroup id="divtopographyId">
        //                                <Label
        //                                    for="topographyId"
        //                                >
        //                                    Topography
        //                                </Label>
        //                                <Input
        //                                    bsSize="sm"
        //                                    type="select"
        //                                    value={form.topographyId}
        //                                    onChange={handleFormFieldChange}
        //                                    name="topographyId"
        //                                    id="topographyId"
        //                                >
        //                                    <option value={0} >Select Topography</option>
        //                                    {form.topographyList.map(c =>
        //                                        <option key={c.id} value={c.id}>{c.value}</option>
        //                                    )}
        //                                </Input>
        //                            </FormGroup>
        //                        </Col>
        //                    </Row>
        //                    <Row>
        //                        <Col sm="4">
        //                        <FormGroup id="divsoilTypePredominantId">
        //                                <Label
        //                                    for="soilTypePredominantId"
        //                                >
        //                                    Soil Type (Predominant)
        //                                </Label>
        //                                <Input
        //                                    bsSize="sm"
        //                                    type="select"
        //                                    value={form.soilTypePredominantId}
        //                                    onChange={handleFormFieldChange}
        //                                    name="soilTypePredominantId"
        //                                    id="soilTypePredominantId"
        //                                >
        //                                    <option value={0} >Select Soil Type</option>
        //                                    {form.soilTypePredominantList.map(c =>
        //                                        <option key={c.id} value={c.id}>{c.value}</option>
        //                                    )}
        //                                </Input>
        //                            </FormGroup>
        //                        </Col>
        //                        <Col sm="4">
        //                            <FormGroup>
        //                                <Label for="soilTypePredominantPercentage"> Soil Type % (Predominant) </Label>
        //                                <Input
        //                                    type="text"
        //                                    name="soilTypePredominantPercentage"
        //                                    id="soilTypePredominantPercentage"
        //                                    bsSize="sm"
        //                                    value={form.soilTypePredominantPercentage}
        //                                    onChange={handleFormFieldChange}
        //                                />
        //                            </FormGroup>
        //                        </Col>
        //                        <Col sm="4">
        //                            <FormGroup>
        //                                <Label for="drainabilityPredominant">Drainability</Label>
        //                                <Input
        //                                    bsSize="sm"
        //                                    value={form.drainabilityPredominant}
        //                                    onChange={handleFormFieldChange}
        //                                    id="drainabilityPredominant"
        //                                    name="drainabilityPredominant"
        //                                    type="select"
        //                                >
        //                                    <option value={0} >Select Drainability</option>
        //                                    {form.drainabilityPredominantList?.map(c =>
        //                                        <option key={c.id} value={c.id}>{c.value}</option>
        //                                    )}
        //                                </Input>
        //                            </FormGroup>
        //                        </Col>
        //                    </Row>
        //                    <Row>
        //                        <Col sm="4">
        //                            <FormGroup>
        //                                <Label
        //                                    for="soilTypeOtherId"
        //                                >
        //                                    Soil Type (Other)
        //                                </Label>
        //                                <Input
        //                                    bsSize="sm"
        //                                    type="select"
        //                                    value={form.soilTypeOtherId}
        //                                    onChange={handleFormFieldChange}
        //                                    name="soilTypeOtherId"
        //                                    id="soilTypeOtherId"
        //                                >
        //                                    <option value={0} >Select Soil Type</option>
        //                                    {form.soilTypeOtherList.map(c =>
        //                                        <option key={c.id} value={c.id}>{c.value}</option>
        //                                    )}
        //                                </Input>
        //                            </FormGroup>
        //                        </Col>
        //                        <Col sm="4">
        //                            <FormGroup>
        //                                <Label for="soilTypeOtherPercentage" > Soil Type % (Other) </Label>
        //                                <Input
        //                                    type="text"
        //                                    name="soilTypeOtherPercentage"
        //                                    id="soilTypeOtherPercentage"
        //                                    bsSize="sm" value={form.soilTypeOtherPercentage}
        //                                    onChange={handleFormFieldChange}
        //                                />
        //                            </FormGroup>
        //                        </Col>
        //                        <Col sm="4">
        //                            <FormGroup>
        //                                <Label for="drainabilityOther">Drainability</Label>
        //                                <Input
        //                                    bsSize="sm"
        //                                    value={form.drainabilityOther}
        //                                    onChange={handleFormFieldChange}
        //                                    id="drainabilityOther"
        //                                    name="drainabilityOther"
        //                                    type="select"
        //                                >
        //                                    <option value={0} >Select Drainability</option>
        //                                    {form.drainabilityOtherList.map(c =>
        //                                        <option key={c.id} value={c.id}>{c.value}</option>
        //                                    )}
        //                                </Input>
        //                            </FormGroup>
        //                        </Col>
        //                    </Row>
        //                </>
        //            }
        //        </CardBody>
        //    </Collapse>
        //</Card>
    )
}

export default AdditionalInformation